import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetSuppliersRequest } from 'app/generated/backend/shipment/api/get-suppliers-request';
import { GetSuppliersResponse } from 'app/generated/backend/shipment/api/get-suppliers-response';

@Injectable()
export class GetSuppliersHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: GetSuppliersRequest
	): Observable<JsonResourceResponse<GetSuppliersResponse>> {
		return this.http.post<JsonResourceResponse<GetSuppliersResponse>>('api/v1/shipment/getSuppliers', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		GetSuppliersHandlerService
	]
})
export class GetSuppliersHandlerModule { }
